import {Pipe, PipeTransform} from '@angular/core';
import {environment} from '../../../environments/environment';

@Pipe({
    name: 'assetSource',
    standalone: false
})
export class AssetSourcePipe implements PipeTransform
{
    private readonly assetSubDirectory: string;

    constructor()
    {
        this.assetSubDirectory = environment.assetSubDirectory;
    }

    transform(imgName: string): string
    {
        return `assets/images/${this.assetSubDirectory}/${imgName}`;
    }
}